import React from 'react'

const TableSimple = ({ block }) => {
  return (
    <section className={`block ${block._template}`}>
      <div className="container">
        <table>
          <thead>
            <tr>
              {block.head_columns.map((column, index) => {
                return <th key={index}>
                  {column.text}
                </th>
              })}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row, index) => {
              let rowColumns = row.columns.map((column, index) => {
                return <td key={index}>
                  {column.text}
                </td>
              })
              return <tr key={index}>
                {rowColumns}
              </tr>
            })}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default TableSimple
